import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('alphaNumWithDash', /^[-0-9a-zA-Z]*$/);
